import { http } from '@/api/http';
import qs from 'qs'

export default {
    /**
     *  Dropdown
     */
    // 培训类别
    getTrainTypeMenu() {
        return http.get('/api/Dropdown/TrainingType');
    },
    // 培训模式（线上、线下）
    getTrainModeMenu() {
        return http.get('/api/Dropdown/TrainingKind');
    },
    // 适用级别
    getForLevelMenu() {
        return http.get('/api/Dropdown/Grad');
    },
    // 知识点 type: ''、 'Theory'、 'Image'
    getKnowledge(data) {
        return http.get(`/api/Dropdown/Knowledge`, data);
    },
    // 考核形式（理论、综合、实操）
    getExamFormMenu() {
        return http.get('/api/Dropdown/AssessMethod');
    },
    // 学分类型
    getCreditTypeMenu() {
        return http.get('/api/Dropdown/CreditType');
    },
    // 排行榜类型
    getRankTypeMenu() {
        return http.get('/api/Dropdown/RankType');
    },
    // 考卷类型
    getPaperType() {
        return http.get('/api/Dropdown/PaperType');
    },
    // 一所设备类型
    getFiscanProduct() {
        return http.get('/api/Dropdown/FiscanProduct');
    },

    /**
     *  培训管理
     */
    // 培训计划
    getTraining(data){
        return http.get('/api/Training/Query', data);
    },
    deleteTraining(id){
        return http.delete('/api/Training/' + id);
    },
    deleteBatchTraining(data){
        return http.delete('/api/Training', data, {contentType: 'form'});
    },
    publishTraining(id){
        return http.put('/api/Training/Publish/' + id);
    },
    pushMessage(id){
        return http.post('/api/Training/PushMessage/' + id);
    },

    getTrainingDetail(id){
        return http.get('/api/TrainingOnline/' + id);
    },
    postTraining(data) {
        return http.post('/api/TrainingOnline', data);
    },
    editTraining(id, data) {
        return http.put(`/api/TrainingOnline/${id}`, data);
    },
    //克隆培训计划
    cloneOnline(id,data){
        return http.post(`/api/TrainingOnline/clone/${id}`, data, {contentType: 'form'});
    },
    //延长结束时间
    extendEndTime(id,data){
        return http.put(`/api/Training/UpdateEndTime/${id}`, data, {contentType: 'form'});
    },
    // 查询参训人员，和queryUsers同一接口，但这里是post
    queryTrainee(data) {
        return http.post('/api/User/Query', data, {contentType: 'form'});
    },


    // 培训记录
    trainingRecord(data){
        return http.get('/api/Training/Records', data);
    },
    getTrainingUsers(id, data){
        return http.get(`/api/TrainingOnline/Trainees/${id}`, data);
    },
    getOfflineUsers(id){
        return http.get(`/api/TrainingOffline/Trainees/${id}`);
    },
    trainingUserTrace(id, data) {
        return http.get(`/api/TrainingOnline/TraineeTrace/${id}`, data);
    },
    // 培训的被动完成
    reviseTraining(id, data) {
        return http.put(`/api/TrainingOnline/Revise/${id}`, data, {contentType: 'form'});
    },
    reviseOffline(id, data) {
        return http.put(`/api/TrainingOffline/Revise/${id}`, data, { contentType: 'form' });
    },
    removeTrainingMember(id, data) {
        return http.put(`/api/TrainingOnline/RemoveMember/${id}`, data, {contentType: 'form'});
    },
    addTrainingMembers(id, data) {
        return http.put(`/api/TrainingOnline/AddMembers/${id}`, data, {contentType: 'form'});
    },
    // 一键补考
    putPaperResit(id) {
        return http.put(`/api/TrainingOnline/AddResit/${id}`);
    },

    /**
     *  线下培训
     */
    postOffline(data) {
        return http.post('/api/TrainingOffline', data);
    },
    editOffline(id, data) {
        return http.put(`/api/TrainingOffline/${id}`, data);
    },
    getOfflineDetail(id){
        return http.get('/api/TrainingOffline/' + id);
    },
    removeOfflineMember(id, data) {
        return http.put(`/api/TrainingOffline/RemoveMember/${id}`, data, {contentType: 'form'});
    },
    addOfflineMembers(id, data) {
        return http.put(`/api/TrainingOffline/AddMembers/${id}`, data, {contentType: 'form'});
    },

    //查询考卷
    getPapers(data) {
        return http.get('/api/Paper/Query', data);
    },
    // 查询某学员的模拟练习list
    getMockReport(id) {
        return http.get(`/api/MockExam/UserReport/${id}`);
    },

    /**
     *  图像
     */
    getCTTree() {
        return http.get('/api/CT/Tree');
    },
    queryCTTree(data) {
        return http.get('/api/CT/Query', data);
    },
    getCTDetail(id) {
        return http.get(`/api/CT/${id}`);
    },
    deleteCT(id){
        return http.delete('/api/CT/' + id);
    },
    deleteCTs(data){
        return http.delete('/api/CT', data, {contentType: 'form'});
    },
    editCT(id, data) {
        return http.put(`/api/CT/${id}`, data, {contentType: 'form'});
    },

    getDRTree() {
        return http.get('/api/DR/Tree');
    },
    queryDRTree(data) {
        return http.get('/api/DR/Query', data);
    },
    getDRDetail(id) {
        return http.get(`/api/DR/${id}`);
    },
    deleteDR(id){
        return http.delete('/api/DR/' + id);
    },
    deleteDRs(data){
        return http.delete('/api/DR', data, {contentType: 'form'});
    },
    editDR(id, data) {
        return http.put(`/api/DR/${id}`, data, {contentType: 'form'});
    },
    //标准图库2020-1-8新加
    getDRSystemTree() {
        return http.get('/api/DR/SystemTree');
    },
    getCTSystemTree() {
        return http.get('/api/CT/SystemTree');
    },
    // 图库知识点 type: ''、 'Theory'、 'Image' 2020-1-8新加
    getSystemKnowledge(data) {
        return http.get(`/api/Dropdown/Knowledge2`, data);
    },
    //标准图库查询
    querySystemDRTree(data) {
        return http.get('/api/DR/QuerySystem2', data);
    },
    querySystemCTTree(data) {
        return http.get('/api/CT/QuerySystem2', data);
    },
    // 修改批次名称（标准图库中用户上传的批次）
    renameDRBatch(id, data) {
        return http.put(`/api/DR/RenameBatch/${id}`, data, {contentType: 'form'});
    },
    renameCTBatch(id, data) {
        return http.put(`/api/DR/RenameBatch/${id}`, data, {contentType: 'form'});
    },

    //用户图库
    //DR目录树
    getDRUserTree(data){
        return http.get('/api/UserDirectory/UserTreeDR',data);
    },
    //CT目录树
    getCTUserTree(data){
        return http.get('/api/UserDirectory/UserTreeCT',data);
    },
    //添加目录
    postUserTree(data){
        return http.post('/api/UserDirectory/Folder', data, {contentType: 'form'})
    },
    //修改文件夹
    putUserTree(id,data){
        return http.put(`/api/UserDirectory/ReName/${id}`, data, {contentType: 'form'})
    },
    //删除文件夹
    deleteUserTree(id){
        return http.delete(`/api/UserDirectory/${id}`)
    },
    //DR图像列表
    getDRUserImage(directoryID, data){
        return http.get('/api/UserDirectory/UserDR/' + directoryID, data);
    },
    getDRUserImageDetail(userImageID) {
        return http.get('/api/UserDirectory/UserImageDR/' + userImageID);
    },
    getDRImageBatch() {
        return http.get('/api/DR/ImageBatch');
    },
    //CT图像列表
    getCTUserImage(directoryID, data){
        return http.get('/api/UserDirectory/UserCT/' + directoryID, data);
    },
    getCTUserImageDetail(userImageID) {
        return http.get('/api/UserDirectory/UserImageCT/' + userImageID);
    },
    getCTImageBatch() {
        return http.get('/api/CT/ImageBatch');
    },
    //用户图库分享
    shareUserImage(id,data){
        return http.post(`/api/UserDirectory/Share/${id}`,data, {contentType: 'form'})
    },
    //标准图库复制
    copySystemImage(id,data){
        return http.post(`/api/UserDirectory/SystemImageCopy/${id}`,data, {contentType: 'form'})
    },
    //用户图库复制
    copyUserImage(id,data){
        return http.post(`/api/UserDirectory/UserImageCopy/${id}`,data, {contentType: 'form'})
    },
    //用户图库移动
    moveUserImage(id,data){
        return http.post(`/api/UserDirectory/UserImageMove/${id}`,data, {contentType: 'form'})
    },
    //删除用户图库图像
    deleteUserImage(data){
        return http.delete('/api/UserDirectory/UserImageDelete',data, {contentType: 'form'})
    },
    // 修改用户图库图像
    putUserImage(id,data){
        return http.put(`/api/UserDirectory/UserImage/${id}`,data, {contentType: 'form'})
    },

    // 我的图库 元素图库
    getFiscan(id) {
        return http.get(`/api/Fiscan/${id}`);
    },
    deleteFiscan(id) {
        return http.delete(`/api/Fiscan/${id}`);
    },
    deleteFiscanArr(data) {
        return http.delete('/api/Fiscan', data, {contentType: 'form'});
    },
    putFiscan(id, data) {
        return http.put(`/api/Fiscan/${id}`, data, {contentType: 'form'});
    },
    getFiscanList(data) {
        return http.get('/api/Fiscan/Query', data, {contentType: 'form'});
    },
    // 包裹图库
    getPackage(id) {
        return http.get(`/api/FiscanPackage/${id}`);
    },
    deletePackage(id) {
        return http.delete(`/api/FiscanPackage/${id}`);
    },
    deletePackageArr(data) {
        return http.delete('/api/FiscanPackage', data, {contentType: 'form'});
    },
    putPackage(id, data) {
        return http.put(`/api/FiscanPackage/${id}`, data, {contentType: 'form'});
    },
    getPackageList(data) {
        return http.get('/api/FiscanPackage/QueryV2', data, {contentType: 'form'});
    },
    // getPackageList(data) {
    //     return http.get('/api/FiscanPackage/Query', data, {contentType: 'form'});
    // },
    getFiscanTree() {
        return http.get('/api/Fiscan/Tree');
    },
    getDisclaimer() {
        return http.get('/api/Fiscan/disclaimer');
    },
    getByTipId(id) {
        return http.get(`/api/Fiscan/GetByTipId?tipId=${id}`);
    },
    // 空包图库
    getEmptyList(data) {
        return http.get('/api/FiscanPackage/QueryEmpty', data, {contentType: 'form'});
    },


    /**
     *  资源
     */
    reNameResource(id, data) {
        return http.put('/api/Resource/ReName/' + id, data, {contentType: 'form'});
    },
    creatResourceFolder(data) {
        return http.post('/api/Resource/Folder', data, {contentType: 'form'});
    },
    getResourceDetail(id) {
        return http.get(`/api/Resource/${id}`);
    },
    queryResourceTree(data) {
        return http.get('/api/Resource/Query', data);
    },
    // 文件是否存在
    queryResourceExistFile(data) {
        return http.get('/api/Resource/ExistsFile', data);
    },
    // 文件夹是否存在
    queryResourceExistFolder(data) {
        return http.get('/api/Resource/ExistsFolder', data);
    },
    deleteResource(id){
        return http.delete('/api/Resource/' + id);
    },
    deleteResources(data){
        return http.delete('/api/Resource', data, {contentType: 'form'});
    },
    copyResource(destID, data) {
        return http.post(`/api/Resource/CopyMulti/${destID}`, data, {contentType: 'form'});
    },
    moveResource(destID, data) {
        return http.post(`/api/Resource/MoveMulti/${destID}`, data, {contentType: 'form'});
    },

    // 查询资源库里所有的某种类型资源，不受文件层级限制。目前用在课件资源选择中
    queryResourceByType(data) {
        return http.get('/api/Resource/QueryByType', data);
    },

    /**
     * 课件
     */
    // 课件类型
    getCourseTypeMenu() {
        return http.get('/api/Dropdown/CoursewareType');
    },
    //查询课件
    getCourse(data) {
        return http.get('/api/Course/Query', data);
    },
    //查询我的课件
    getMyCourse(data) {
        return http.get('/api/Course/Mine', data);
    },
    //选择图像
    queryDRList(data) {
        return http.get('/api/DR/Query2', data);
    },
    queryCTList(data) {
        return http.get('/api/CT/Query2', data);
    },
    //理论课件详情
    getTheoryCourseDetail(id){
        return http.get('/api/TheoryCourse/' + id);
    },
    //理论课件添加
    postTheoryCourse(data) {
        return http.post('/api/TheoryCourse', data);
    },
    //理论课件修改
    putTheoryCourse(id, data) {
        return http.put(`/api/TheoryCourse/${id}`, data);
    },
    //CT课件详情
    getCTCourseDetail(id){
        return http.get('/api/CTCourse/' + id);
    },
    //CT课件添加
    postCTCourse(data) {
        return http.post(`/api/CTCourse`, data);
    },
    //CT课件修改
    editCTCourse(id, data) {
        return http.put(`/api/CTCourse/${id}`, data);
    },
    //DR课件详情
    getDRCourseDetail(id){
        return http.get('/api/DRCourse/' + id);
    },
    //CT课件添加
    postDRCourse(data) {
        return http.post(`/api/DRCourse`, data);
    },
    //CT课件修改
    editDRCourse(id, data) {
        return http.put(`/api/DRCourse/${id}`, data);
    },
    //课件删除 单个
    deleteCourseSingle(id){
        return http.delete('/api/Course/' + id);
    },
    //课件批量删除
    deleteCourseBatch(data){
        return http.delete('/api/Course', data, {contentType: 'form'});
    },

    /**
     * 考题
     */
    getMyTopic(data) {
        return http.get(`/api/Topic/mine`, data);
    },
    getTopicList(data) {
        return http.get(`/api/Topic/Query`, data);
    },
    getTheoryTopicDetail(id) {
        return http.get('/api/TheoryTopic/' + id);
    },
    // 难易程度
    getDifficulty() {
        return http.get(`/api/Dropdown/Difficulty`);
    },
    getQuestionType() {
        return http.get(`/api/Dropdown/TopicType`);
    },
    addTheoryTopic(data) {
        return http.post(`/api/TheoryTopic`, data);
    },
    editTheoryTopic(id, data) {
        return http.put(`/api/TheoryTopic/${id}`, data);
    },
    // 通过前端的方式批量导入理论题
    importTheoryTopic(query, data) {
        let queryString = qs.stringify(query)
        return http.post(`/api/TheoryTopic/import?${queryString}`, data);
    },
    addPairTopic(data) {
        return http.post(`/api/TheoryTopic/Pair`, data);
    },
    editPairTopic(id, data) {
        return http.put(`/api/TheoryTopic/Pair/${id}`, data);
    },
    addCtTopic(data) {
        return http.post(`/api/CTTopic`, data);
    },
    addDrTopic(data) {
        return http.post(`/api/DRTopic`, data);
    },
    getCtTopic(id) {
        return http.get('/api/CTTopic/' + id)
    },
    getDrTopic(id) {
        return http.get('/api/DRTopic/' + id)
    },
    // 这个接口的dr含有tip
    getDrTopicInPaper(id) {
        return http.get('/api/DRTopic/4Paper/' + id)
    },
    putCtTopic(id, data) {
        return http.put('/api/CTTopic/' + id, data)
    },
    putDrTopic(id, data) {
        return http.put('/api/DRTopic/' + id, data)
    },
    importExcelTopic(fileData){
        return http.post(`/api/Import/Excel/Topic`, fileData, {contentType: 'file', timeout: 60000, noShowError: true});
    },
    importWordTopic(fileData){
        return http.post(`/api/Import/Word/Topic`, fileData, {contentType: 'file', timeout: 60000, noShowError: true});
    },
    //配图题
    getAnswerType() {
        return http.get(`/api/Dropdown/AnswerKnowledge`);
    },
    /**
     * 考卷
     */
    getMyPaper(data) {
        return http.get('/api/Paper/mine', data);
    },
    getPaperList(data) {
        return http.get('/api/Paper/Query', data);
    },
    deleteMyPaper(id) {
        return http.delete('/api/Paper/' + id);
    },
    deleteMyPapers(data){
        return http.delete('/api/Paper', data, {contentType: 'form'});
    },
    //考卷修改保存
    putPaper(id, data){
        return http.put(`/api/Paper/${id}`, data);
    },
    //提交组卷
    postPaper(data) {
        return http.post('/api/Paper', data);
    },
    getTheoryPaperDetail(id) {
        return http.get(`/api/TheoryPaper/${id}`);
    },
    // 考卷导入 type{string}: Word || Excel
    importTopicPreview(type, formData) {
        return http.post(`/api/Import/${type}/TopicPreview`, formData, {contentType: 'file', timeout: 60000});
    },
    //理论自动组卷
    theoryPaperAutomatic(data) {
        return http.post('/api/TheoryPaper/Automatic', data);
    },
    //手动选题列表
    getTheoryTopic(data) {
        return http.get('/api/TheoryTopic/Query', data);
    },
    //理论题量获取
    getTopicStock(data) {
        return http.get('/api/TheoryPaper/TopicStock', data);
    },
    //提交导入组卷
    addPaperByImport(data) {
        return http.post('/api/TheoryPaper/Import', data);
    },
    //图像自动组卷
    imagePaperAutomatic(data) {
        return http.post('/api/ImagePaper/Automatic', data);
    },
    //考卷形式
    getPaperPattern() {
        return http.get(`/api/Dropdown/Pattern`);
    },
    // 组卷方式
    getPaperMethod() {
        return http.get(`/api/Dropdown/PaperMethod`);
    },
    //手动图像考题DR列表
    getDRTopicList(data) {
        return http.get('/api/DRTopic/4paper/Query', data);
    },
    //手动图像考题CT列表
    getCTTopicList(data) {
        return http.get('/api/CTTopic/Query', data);
    },
    //DR考卷详情
    getDRPaper(id){
        return http.get('/api/DRPaper/' + id);
    },
    //CT考卷详情
    getCTPaper(id){
        return http.get('/api/CTPaper/' + id);
    },
    //CT题量获取
    getCTTopicStock(data) {
        return http.get('/api/CTPaper/TopicStock', data);
    },
    //CT题量获取
    getDRTopicStock(data) {
        return http.get('/api/DRPaper/TopicStock', data);
    },
    //考题删除 单个
    deleteTopicSingle(id){
        return http.delete('/api/Topic/' + id);
    },
    //考题批量删除
    deleteTopicBatch(data){
        return http.delete('/api/Topic', data, {contentType: 'form'});
    },
    //获取每个视角的每个知识点的图像数量
    getKPImageCount(viewCount) {
        return http.get(`/api/DRPaper/ImageStockByViewCount?viewCount=${viewCount}`);
    },
    getUserKPImageCount(data) {
        return http.get(`/api/DRPaper/UserImageStockByDirectory`, data, {contentType: 'form'});
    },
    //tip组卷提交
    postTipPaper(data) {
        return http.post('/api/DRPaper/TipCombination', data);
    },
    postTipImagePaper(data) {
        return http.post('/api/DRPaper/TipCombination2', data);
    },
    // 调研管理
    addSurveyPaper(data) {
        return http.post('/api/Survey', data);
    },
    deleteSurveyPaper(data) {
        return http.delete('/api/Survey', data, {contentType: 'form'});
    },
    surveyUpdate(id, data) {
        return http.put(`/api/Survey/Update/${id}`, data);
    },
    getSurveyList(data) {
        return http.get('/api/Survey/Query', data);
    },
    getSurveyTemplate(id) {
        return http.get(`/api/Survey/Template/${id}`);
    },


    // 培训计划关联调研问卷
    trainSurveyAttach(id, data) {
        return http.put(`/api/Training/AttachSurvey/${id}`, data, {contentType: 'form'});
    },
    getTrainSurveyAttached(id) {
        return http.get(`/api/Training/SurveyAttached/${id}`);
    },

    //开岗放权
    getPreJobList(data){
        return http.get('/api/PreJobApprove/Query', data);
    },
    getPreJob(id) {
        return http.get(`/api/PreJobApprove/ByUser/${id}`);
    },
    addPreJob(data) {
        return http.post('/api/PreJobApprove/Upsert', data, {contentType: 'form'});
    },
    deletePreJob(data) {
        return http.post('/api/PreJobApprove/Remove', data, {contentType: 'form'});
    },

    //培训师首页
    //基本信息
    getTraineeData() {
        return http.get(`/api/Dashboard/Teacher/Amount`);
    },
    //上月上传趋势
    getUploadRecent() {
        return http.get(`/api/Dashboard/Teacher/Trend`);
    },
    //培训任务分析
    getTaskAnalyse() {
        return http.get(`/api/Dashboard/Teacher/Analyse`);
    },
    //快捷入口
    getShortcutMenu() {
        return http.get(`/api/Dashboard/Teacher/ShortcutMenu`);
    },
    //培训计划详情
    getTrainList() {
        return http.get(`/api/Dashboard/Teacher/TrainList`);
    },
    //培训计划完成情况
    gettaskFinish() {
        return http.get(`/api/Dashboard/Teacher/Progresses`);
    },
    // 开岗放权
    getProJobMenu() {
        return http.get('/api/Dropdown/PreJobApproval');
    },
    //开放放权导入
    importPreJob(fileData){
        return http.post(`/api/Import/Excel/PrejobApproval`, fileData, {contentType: 'file'});
    },
    //开岗放权导出
    exportPreJob(data){
        return http.get(`/api/Export/Excel/PrejobApproval`, data);
    },
    //图像查询
    getImageList(data){
        return http.get('/api/tempimage/Query', data);
    },
    //修改图像信息
    editImageInfo(id,data){
        return http.put(`/api/tempimage/${id}`, data, {contentType: 'form'});
    },
    //删除图像
    deleteImageUpload(data){
        return http.delete('/api/tempimage', data, {contentType: 'form'});
    },
    //同步到图像库
    synchronizeToLibray(data){
        return http.post('/api/tempimage/synchronous', data,{contentType: 'form'});
    },
    // 调查管理New
    postSurveyNew(data) {
        return http.post('/surveyapi/template', data);
    },
    deleteSurveyNew(id) {
        return http.delete(`/surveyapi/template/${id}`);
    },
    surveyNewUpdate(id, data) {
        return http.put(`/surveyapi/template/${id}`, data);
    },
    getSurveyNewList(data) {
        return http.get('/surveyapi/template/query', data);
    },
    getSurveyNewTemplate(id) {
        return http.get(`/surveyapi/template/${id}`);
    },
    postQuestionnaire(data) {
        return http.post('/surveyapi/questionnaire', data, {contentType: 'form'});
    },

    // 调查统计
    getQuestionnaires() {
        return http.get('/surveyapi/questionnaire/query');
    },
    getQuestionnaireDetail(id) {
        return http.get(`/surveyapi/questionnaire/${id}`);
    },
    getQuestionnaireUser(id) {
        return http.get(`/surveyapi/questionnaire/${id}/replies`);
    },
    deleteQuestionnaire(id) {
        return http.delete(`/surveyapi/questionnaire/${id}`);
    },
    // 某一道题的作答情况（主观）
    getQuestionDetail(paperId, questionId) {
        return http.get(`/surveyapi/questionnaire/${paperId}/question/${questionId}/replies`);
    },
    // 查看某人答卷
    getQuestionnairePaper(paperId, userId) {
        return http.get(`/surveyapi/questionnaire/${paperId}/reply`,{userId});
    },
    //打开调查
    openQuestionnaire(id) {
        return http.put(`/surveyapi/questionnaire/${id}/open`);
    },
    //关闭调查
    closeQuestionnaire(id) {
        return http.put(`/surveyapi/questionnaire/${id}/close`);
    },

    /**
     * 群组
     */
    queryUserGroup(data){
        return http.get(`/api/Group/Query`,data);
    },
    postUserGroup(data){
        return http.post(`/api/Group`,data,{contentType:'form'})
    },
    editUserGroup(id,data){
        return http.put(`/api/Group/${id}`,data,{contentType:'form'})
    },
    getGroupDetail(id){
        return http.get(`/api/Group/${id}`)
    },
    getGroupMember(id){
        return http.get(`/api/Group/Members/${id}`)
    },
    editGroupMember(id,data){
        return http.put(`/api/Group/Members/${id}`,data,{contentType:'form'})
    },
    deleteUserGroup(id){
        return http.delete(`/api/Group/${id}`)
    },

    //台账管理
    queryStandingBook(data){
        return http.get(`/api/standing-book/query`,data);
    },
    getStandingBook(id) {
        return http.get(`/api/standing-book/${id}`);
    },
    deleteStandingBook(data){
        return http.delete(`/api/standing-book`,data,{contentType:'form'})
    },
    postStandingBook(data) {
        return http.post(`/api/standing-book`, data)
    },
    editStandingBook(data) {
        return http.put(`/api/standing-book`, data)
    },
    queryTraineeBook(data){
        return http.get(`/api/standing-book/trainees/summary`,data);
    },
    getTraineeBook(id,data) {
        return http.get(`/api/standing-book/trainee/${id}/details`,data);
    },
    /**
     * 知识库
     */
    queryAsset(data){
        return http.get(`/api/Asset/Query`, data);
    },
    postAsset(data){
        return http.post(`/api/Asset`, data)
    },
    editAsset(id,data){
        return http.put(`/api/Asset/${id}`, data)
    },
    getAssetpDetail(id){
        return http.get(`/api/Asset/${id}`)
    },
    deleteAsset(id){
        return http.delete(`/api/Asset/${id}`)
    },
    deleteAssets(data){
        return http.delete(`/api/Asset`, data, {contentType: 'form'})
    },

    /**
     *  直播
     */
    // 更新房间信息
    putLiveRoom(data) {
        return http.put(`/api/live/room`, data)
    },
    // 我的房间信息查询
    getLiveRoom(){
        return http.get(`/api/live/room/mine`);
    },
    // 获取房间推流地址
    getLiveRoomRtmp(){
        return http.get(`/api/live/room/url/push/rtmp`);
    },
    deleteLiveRoom(){
        return http.delete(`/api/live/room/mine`);
    },


}
